module.exports = __webpack_public_path__ + "static/raven-55e882fa0256b7fe7eb65900c799b5a2.jpeg";